// extracted by mini-css-extract-plugin
module.exports = {"filter":"filter-07c12466","select":"select-d529f01f","school":"school-3005ff27"};